import React, { useEffect, useState } from "react";
import theme from "../../Styles/theme";
import Modal from "react-modal";
import { Button, Container, HandleButton, HandleInput, Input, Title } from "./styles";
import { ModalDivX } from "../ModalDivX";
import { useCartorio } from "../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../Hooks/funcionarioCartorio";
import { IOperacao, useOperacao } from "../../Hooks/operacoes";
import api from "../../Services/api";
import { ModalLoader } from "../ModalLoader";
import { Alert } from "../Error/Alert";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  operacao: IOperacao;
}

export function Editar_Excluir_Operacoes({ open, onClose, operacao }: Props) {
  const { cartorio, cartorioIsLogged, checarToken } = useCartorio();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const [step, setStep] = useState(1 as 1 | 2);

  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  const { handleAddOperacao,handleDeleteOperacao, handleUpdateOperacao } = useOperacao();

  function handleClose() {
    setStep(1);
    setDescricao("");
    onClose();
  }
  const [DESCRICAO, setDescricao] = useState("");

  async function post() {
    if (DESCRICAO.trim().length == 0) {
      setError({
        title: "Descrição inválida",
        message: "Não é permitida a criação de uma operação sem descrição!",
      });
      return;
    }

    try {
      setLoading(true);
      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      }
      if (cartorioIsLogged) {
        await checarToken();
      }
      const { data } = await api.put(`/tipos-operacoes`, {
        DESCRICAO,
        CARTORIO_ID: operacao.CARTORIO_ID,
        ID:operacao.ID
      });

      handleUpdateOperacao(data);
      handleClose();
    } catch (error) {
      setError({
        title: "Ops",
        message:
          "Não foi possível cadastrar a operação, tente novamente mais tarde!",
      });
    } finally {
      setLoading(false);
    }
  }

  async function excluir() {
   

    try {
      setLoading(true);
      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      }
      if (cartorioIsLogged) {
        await checarToken();
      }
      const { data } = await api.delete(`/tipos-operacoes/${operacao.ID}`);

      handleDeleteOperacao(operacao);
      handleClose();
    } catch (error) {
      setError({
        title: "Ops",
        message:
          `Não foi possível excluir ${operacao.DESCRICAO}!`,
      });
    } finally {
      setLoading(false);
    }
  }



useEffect(() => {
  setDescricao(operacao.DESCRICAO)
},[operacao.ID])
  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <Container>
        <ModalDivX execute={handleClose} />

        {step == 1 ? (
            <>
             <Title>Qual operação deseja executar com <b>{operacao.DESCRICAO}</b></Title>
          <HandleButton>
             
            <Button onClick={()=>{setStep(2)}}>EDITAR</Button>
            <Button onClick={excluir}>EXCLUIR</Button>
          </HandleButton>
          </>
        ) : (
          <>
            {" "}
            <HandleInput>
              <Input
                value={DESCRICAO}
                onChange={(ev) => {
                  setDescricao(ev.target.value);
                }}
                placeholder={"DESCRIÇÃO"}
              />
            </HandleInput>
            <HandleButton>
              <Button onClick={handleClose}>Cancelar</Button>
              <Button onClick={post}>Confimar</Button>
            </HandleButton>
          </>
        )}
      </Container>
      <ModalLoader loading={loading} />
      <Alert
        title={error.title}
        message={error.message}
        open={error.message.length > 0}
        onClose={() => {
          setError({ title: "", message: "" });
        }}
      />
    </Modal>
  );
}
